import {
  Directive,
  inject,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { getFeatures } from '@fc-store/selectors/features.selectors';
import { FeatureFlagService } from '@fc-core/feature-flags/feature-flag.service';
import { FeatureKey } from '@fc-core/feature-flags/feature.model';

@Directive({
  selector: '[fcHasFeature]',
  standalone: false,
})
export class HasFeatureDirective implements OnInit, OnDestroy {
  @Input() fcHasFeature: FeatureKey;
  isVisible = false;
  private subscription: Subscription = new Subscription();

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private store: Store,
  ) {}

  private featureFlags = inject(FeatureFlagService);

  ngOnInit(): void {
    this.subscription = this.store
      .pipe(select(getFeatures))
      .subscribe((features) => {
        if (!features) {
          this.viewContainerRef.clear();
        }
        if (features && this.featureFlags.enabled(this.fcHasFeature)()) {
          if (!this.isVisible) {
            this.isVisible = true;
            this.viewContainerRef.createEmbeddedView(this.templateRef);
          }
        } else {
          this.isVisible = false;
          this.viewContainerRef.clear();
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
